import { Injectable } from '@angular/core';
import { DefaultService, NaturalGasProvider, BaseResponseDTO } from '@psnb/psnb-api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NaturalGasProviderService {

  constructor(private powerSupplyService: DefaultService) {
    this.getAllNaturalGasProviderFromService();
  }
  
  getAllNaturalGasProviderFromService() {
    return this.powerSupplyService.getNaturalGasProviders().pipe(map(result => result));
  }

  createNaturalGasProvider(naturalGasProvider: NaturalGasProvider) {
    return this.powerSupplyService.createNaturalGasProvider(naturalGasProvider).pipe(map(result => result));
  }

  updateNaturalGasProvider (naturalGasProvider: NaturalGasProvider) {
    return this.powerSupplyService.updateNaturalGasProvider(naturalGasProvider).pipe(map(result => result));
  }

  deleteNaturalGasProvider(id: number): Observable<BaseResponseDTO> {
    return this.powerSupplyService.deleteNaturalGasProvider(id).pipe(map(result => result));
  }
}
